import { regex } from '../constants';

export const required = value => ({
    error: !value ? 'This field is required.' : null,
});

export const email = value => ({
    error: !value || !regex.email.test(value) ? 'Invalid Email' : null,
});
